export default __webpack_public_path__ + "static/media/popcorn-pieces-06.a4c0b63b.png";